import Storage from "@/app/core/util/Storage";
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Loading from "@/app/core/layouts/main/components/Loading";
import { RealtyHelper } from "@/app/core/util/helpers/RealtyHelper";
import { PropertiesController } from "@/app/core/base/controllers/PropertiesController";
import OwnerRealtyCard from "@/app/core/layouts/main-components/realty/OwnerRealtyCard";

export default function AnunciosComponent() {
  const userData = Storage.getUserData();
  const [loading] = useState(false);
  const [data, setData] = useState([]);
  const enviroment = process.env.REACT_APP_ENV;

  useEffect(() => {
    loadAutomations();
  }, []);

  async function loadAutomations() {
    if (userData.realEstate) {
      PropertiesController.ListByRealEstate((res) => setData(res));
    } else {
      PropertiesController.ListByUser((res) => setData(res));
    }
  }

  return (
    <>
      <div className="content">
        <div className="row">
          <div className="col-8">
            <div className="content-heading">
              <h3>Anúncios</h3>
            </div>
          </div>
          <div className="col-4">
            <a
              className="btn btn-warning mt-4 btn-block"
              href="#/anunciar-imovel"
            >
              <i className="si si-plus" /> Adicionar anúncio
            </a>
          </div>
          {data &&
            data.map((item) => (
              <div key={item.id} className="col-md-4">
                <OwnerRealtyCard data={item} reload={() => loadAutomations()} />
              </div>
            ))}
          {data && data.length === 0 ? (
            <div className="col-12 text-center py-8">
              <h4>Você não tem anúncios</h4>
              <a className="btn btn-warning mt-4" href="#/anunciar-imovel">
                <i className="si si-plus" /> Clique aqui para adicionar anúncio
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Loading loading={loading} />
      <ToastContainer className="toastr" />
    </>
  );
}
